/*
 * Copyright (c) All right reserved Anvish Inc. 2025
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */
"use client";
import CountUp from "react-countup";
import React from "react";

interface AnimatedCounterProps {
  endValue: number;
  suffix?: string;
}

const AnimatedCounter: React.FC<AnimatedCounterProps> = ({
  endValue,
  suffix,
}) => {
  return (
    <CountUp
      duration={1}
      enableScrollSpy={true}
      end={endValue}
      separator=""
      start={0}
      suffix={suffix ? suffix : ""}
    >
      {({ countUpRef, start }) => <span ref={countUpRef} />}
    </CountUp>
  );
};

export default AnimatedCounter;
